import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  MaintenanceConcessionaire,
  RegionCpeticionario,
} from "../models/maintenance-concesssionaire";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class ConcessionaireService {
  env = environment.env;
  maintenanceConcessionaireURL = endpointsURL.maintenanceConcessionaireURL;

  constructor(private httpClient: HttpClient) {}

  public list(filters: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenanceConcessionaireURL}/lista${filters}`
    );
  }

  public getConcessionaire(id: string): Observable<MaintenanceConcessionaire> {
    return this.httpClient.get<MaintenanceConcessionaire>(
      `${this.env}${this.maintenanceConcessionaireURL}?_identificador=${id}`
    );
  }

  public updateConcessionaire(
    concessionaire: MaintenanceConcessionaire,
    coId: string
  ): Observable<MaintenanceConcessionaire> {
    return this.httpClient.put<MaintenanceConcessionaire>(
      `${this.env}${this.maintenanceConcessionaireURL}?_identificador=${coId}`,
      concessionaire
    );
  }

  public createConcessionaire(
    concessionaire: MaintenanceConcessionaire
  ): Observable<MaintenanceConcessionaire> {
    return this.httpClient.post<MaintenanceConcessionaire>(
      `${this.env}${this.maintenanceConcessionaireURL}`,
      concessionaire
    );
  }

  public deleteConcessionaire(
    ids: string[]
  ): Observable<MaintenanceConcessionaire> {
    let params = new HttpParams();

    ids.forEach((e) => {
      params = params.append("_id", e);
    });
    return this.httpClient.delete<MaintenanceConcessionaire>(
      `${this.env}${this.maintenanceConcessionaireURL}`,
      { params: params }
    );
  }

  public getRegionByConcessionaire(
    id: string
  ): Observable<RegionCpeticionario> {
    return this.httpClient.get<RegionCpeticionario>(
      `${this.env}${this.maintenanceConcessionaireURL}/getRegion?_identificador=${id}`
    );
  }
}
